// extracted by mini-css-extract-plugin
export default {"column__text":"styles_column__text__qfieE","placeholder__text-more":"styles_placeholder__text-more__PsUGS"};